import { Language } from '../../lang/Language'

export class CantRaiseLessThanMaxError extends Error {
  constructor() {
    super(Language.strings.error.table.cantRaiseLessThanMax)
  }
}
